import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

import { PrintStyleSheet } from "../../seller/advert-seller-details/location/location.styles";

export const LeasingTermsAndConditions = styled.div`
  background-color: ${({ theme }) => ThemeSelectors.getLightGrey(theme)};
  padding: ${({ theme }) => ThemeSelectors.getRelatedOneSpacing(theme)};
  margin-top: ${({ theme }) => ThemeSelectors.getDistinctTwoSpacing(theme)};
  margin: ${({ theme }) => ThemeSelectors.getDistinctTwoSpacing(theme)} 0;
  max-width: 1224px;
  ${PrintStyleSheet}

  @media (min-width: 950px) {
    margin: 0 auto 72px;
  }
`;
